import React, {useState} from 'react';
import {ActivityIndicator, Alert, Text, View} from 'react-native';
import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import Input from '../../../../components/Input/Input';
import {styles} from './styles';
import ProfileService from '../../../../services/ProfileService/ProfileService';
import { Colors } from '../../../../constants/Colors';
import { showSuccess } from '../../../../utils/globalAlert';

interface IChangePasswordDrop {
  onSave: () => void;
}

const ChangePasswordDrop = ({onSave}: IChangePasswordDrop) => {
  const [data, setData] = useState<IPasswords>({
    password: '',
    newPassword: '',
    confirmationNewPassword: '',
  });

  const [loading, setLoading] = useState<boolean>(false);
  const [fieldErrors, setFieldErrors] = useState<{
    newPassword?: string;
    confirmationNewPassword?: string;
  }>({});

  const UpdatePassword = async () => {
    if (data.newPassword.length < 8) {
      setFieldErrors(prev => ({
        ...prev,
        newPassword: 'A nova senha deve ter pelo menos 8 caracteres',
      }));
      Alert.alert(
        'Validação dos campos',
        'A nova senha deve ter pelo menos 8 caracteres',
      );
      return;
    }

    if (data.newPassword !== data.confirmationNewPassword) {
      setFieldErrors(prev => ({
        ...prev,
        confirmationNewPassword: 'As senhas não são iguais',
      }));
      Alert.alert('Validação dos campos', 'As senhas não são iguais');
      return;
    }

    setLoading(true);
    setFieldErrors({});
    try {
      const response = await ProfileService.updatePasswordPost(data);
      showSuccess('Sucesso', String(response?.details )|| 'Senha alterada com sucesso');
      onSave();
    } catch (error) {
      Alert.alert(
        'Erro',
        String(error?.response?.data?.details) || 'Erro ao alterar senha',
      );
      console.error(error);
    }
    setLoading(false);
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Alterar Senha</Text>
      <View style={styles.containerInput}>
        <Input
          title="Senha atual"
          placeholder="Senha atual..."
          hasSecurity
          onChangeText={text => setData({...data, password: text})}
        />
        <Input
          title="Senha nova"
          placeholder="Senha nova..."
          hasSecurity
          mt={10}
          error={fieldErrors.newPassword}
          onChangeText={text => {
            setData({...data, newPassword: text});
            setFieldErrors(prev => ({...prev, newPassword: undefined}));
          }}
        />
        <Input
          title="Confirmar nova senha"
          placeholder="Confirmar nova senha..."
          hasSecurity
          mt={10}
          error={fieldErrors.confirmationNewPassword}
          onChangeText={text => {
            setData({...data, confirmationNewPassword: text});
            setFieldErrors(prev => ({
              ...prev,
              confirmationNewPassword: undefined,
            }));
          }}
        />
        <View style={styles.containerButton}>
          {loading ? (
            <ActivityIndicator
               color={Colors.RedPallete.red}
              size={20}
              style={{
                alignSelf: 'center',
              }}
            />
          ) : (
            <ButtonComponent
              title="Salvar"
              width="100%"
              onPress={UpdatePassword}
            />
          )}
        </View>
      </View>
    </View>
  );
};

export default ChangePasswordDrop;
